<script>
	import OtherSkills from './OtherSkills.svelte';
	import School from './School.svelte';
	import Timeline from './Timeline.svelte';
	import Experience from './Experience.svelte';
	import { githubUserStore } from './../store/githubUserStore.js';
    import {onMount} from 'svelte';
    

    // fetch data from github api and set it to store using node fetch
    onMount(async () => {
        const response = await fetch('https://api.github.com/users/rAheebwa');
        const data = await response.json();
        githubUserStore.set(data);
    });

    const stacks = [
        {
            "name": "NodeJS",
            "percent": "90",
            "color": "#6c757d",
            "icon": "fab fa-node"
        },
        {
            "name": "React",
            "percent": "80",
            "color": "#6c757d",
            "icon": "fab fa-react"
        },
        {
            "name": "Svelte",
            "percent": "75",
            "color": "#6c757d",
            "icon": "fab fa-svelte"
        },
        {
            "name": "Laravel",
            "percent": "90",
            "color": "#6c757d",
            "icon": "fab fa-laravel"
        },
        {
            "name": "Rails",
            "percent": "85",
            "color": "#6c757d",
            "icon": "fab fa-rails"
        }
    ];

    // order stacks by name
    stacks.sort((a, b) => {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    });

    const languages = [
        {
            "name": "HTML5/CSS3",
            "percent": "95",
            "color": "#6c757d",
            "icon": "fab fa-html5"
        },
        {
            "name": "JavaScript/ES6",
            "percent": "75",
            "color": "#6c757d",
            "icon": "fab fa-js"
        },
        {
            "name": "PHP",
            "percent": "90",
            "color": "#6c757d",
            "icon": "fab fa-php"
        },
        {
            "name": "Ruby",
            "percent": "85",
            "color": "#6c757d",
            "icon": "fab fa-python"
        },        
        {
            "name": "SQL",
            "percent": "90",
            "color": "#6c757d",
            "icon": "fab fa-python"
        },
    ];

    // order languages by name
    languages.sort((a, b) => {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    });

    const skills = [
        {
            "name": "Git",
            "percent": "90",
            "color": "#6c757d",
            "icon": "fab fa-git"
        },
        {
            "name": "GraphQL",
            "percent": "80",
            "color": "#6c757d",
            "icon": "fab fa-github"
        },
        {
            "name": "Selenium",
            "percent": "75",
            "color": "#6c757d",
            "icon": "fab fa-gitlab"
        },
        {
            "name": "Slack",
            "percent": "90",
            "color": "#6c757d",
            "icon": "fab fa-git-alt"
        },
        {
            "name": "Agile",
            "percent": "85",
            "color": "#6c757d",
            "icon": "fab fa-github-alt"
        }
    ];

    // order skills by name
    skills.sort((a, b) => {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    });

    const others = [
        {
            "name": "Heroku",
            "percent": "90",
            "color": "#6c757d",
            "icon": "fab fa-github"
        },
        {
            "name": "AWS",
            "percent": "80",
            "color": "#6c757d",
            "icon": "fab fa-gitlab"
        },
        
        {
            "name": "NoSQL",
            "percent": "85",
            "color": "#6c757d",
            "icon": "fab fa-python"
        },
        {
            "name": "Digital Ocean",
            "percent": "90",
            "color": "#6c757d",
            "icon": "fab fa-gitlab"
        },
        {
            "name": "TDD",
            "percent": "85",
            "color": "#6c757d",
            "icon": "fab fa-git-alt"
        },
    ];

    // order others by name
    others.sort((a, b) => {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    });

</script>

<svelte:head>
    <title>rAheebwa &middot; My Online Place</title>
</svelte:head>

<!-- boostrap card displaying user data from store -->
<div class="row">
    <div class="col-md-6">
        <div class="card text-center bg-transparent" style="background-color: transparent ;">
            <div class="card-body">
                <!-- avatar -->
                <img src="{$githubUserStore.avatar_url}" class="rounded-circle img-thumbnail" alt="avatar" width="300" height="300">
                <h5 class="card-title py-4">Hi, I'am {$githubUserStore.name}</h5>
                <p class="card-text">{$githubUserStore.bio}</p>
                <a href={$githubUserStore.html_url} class="btn btn-secondary btn-lg">Github Profile</a>
            </div>
        </div>
    </div>
    <div class="col-md-6">
        <div class="list-group">
            <span class="list-group-item list-group-item-action bg-secondary text-white">Professional Summary</span>
            <span class="list-group-item list-group-item-action">A self-driven, results-oriented, high organized and detail-oriented individual with five years experience in software development and strategic problem-solving.
Experienced in leading and working alongside teams to convert diverse opinions into meaningful actions. Excellent relationship builder with proven interpersonal skills.</span>
            <span class="list-group-item list-group-item-action bg-secondary text-white">Skills</span>
            <span class="list-group-item">
                <div class="row">
                    
                    <div class="col-md-6">
                        <h6>Languages</h6>
                        {#each languages as language}
                        <div class="progress mb-1" style="height: 18px ;">
                            <div class="progress-bar bg-purple" role="progressbar" style="width: {language.percent}%" aria-valuenow="{language.percent}" aria-valuemin="0" aria-valuemax="100">
                                <span class="sr-only">{language.name} ( {language.percent}% )</span>
                            </div>
                        </div>
                        {/each}
                    </div>
                    <div class="col-md-6">
                        <h6>Stacks</h6>
                        {#each stacks as stack}
                        <div class="progress mb-1" style="height: 18px ;">
                            <div class="progress-bar bg-teal text-primary" role="progressbar" style="width: {stack.percent}%" aria-valuenow="{stack.percent}" aria-valuemin="0" aria-valuemax="100">
                                <span class="sr-only">{stack.name} ( {stack.percent}% )</span>
                            </div>
                        </div>
                        {/each}
                    </div>

                    <div class="col-md-6">
                        <h6>Essential Skills</h6>
                        {#each skills as skill}
                        <div class="progress mb-1" style="height: 18px ;">
                            <div class="progress-bar bg-info text-primary" role="progressbar" style="width: {skill.percent}%" aria-valuenow="{skill.percent}" aria-valuemin="0" aria-valuemax="100">
                                <span class="sr-only">{skill.name} ( {skill.percent}% )</span>
                            </div>
                        </div>
                        {/each}
                    </div>
                    <div class="col-md-6">
                        <h6>Others</h6>
                        {#each others as other}
                        <div class="progress mb-1" style="height: 18px ;">
                            <div class="progress-bar bg-pink text-light" role="progressbar" style="width: {other.percent}%" aria-valuenow="{other.percent}" aria-valuemin="0" aria-valuemax="100">
                                <span class="sr-only">{other.name} ( {other.percent}% )</span>
                            </div>
                        </div>
                        {/each}
                    </div>
                </div>
            </span>
            </div>

            <button href="resume.pdf" class="btn btn-secondary my-2 w-100">Download my CV</button>
    </div>
</div>

<div class="row my-5">
    <div class="col-md-6">
        <Experience/>
    </div>
    
    <div class="col-md-6">
        <School/>
        <OtherSkills/>
    </div>
</div>